<template>
  <div class="loading-screen">
    <h2>LOADING<span class="loader"></span></h2>
    <div class="container">
      <div class="loading"></div>
      <img class="initial-loading" src="/paw.svg" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingScreen",
};
</script>

<style scoped>
h2 {
  z-index: 9999;
  padding-block-end: 5em;
}
.container {
  overflow: visible;
  top: 0;
  transform: rotate(180deg);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9998;
}
.loading {
  overflow: visible;
  width: 4em;
  aspect-ratio: 1;
  position: relative;
}

.initial-loading {
  width: 4em;
  aspect-ratio: 1;
  position: absolute;
  right: 50%;
  transition: var(--transition);
  animation-name: secondPaw;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.loading::before {
  content: "";
  width: 4em;
  aspect-ratio: 1;
  position: absolute;
  left: 80%;
  top: -130%;
  background: url("/paw.svg");
  background-size: contain;
  background-repeat: no-repeat;
  transform: rotateY(180deg);
  transition: var(--transition);
  animation-name: firstPaw;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.loading::after {
  content: "";
  width: 4em;
  aspect-ratio: 1;
  position: absolute;
  top: 130%;
  left: 80%;
  background: url("/paw.svg");
  background-size: contain;
  background-repeat: no-repeat;
  transform: rotateY(180deg);
  transition: var(--transition);
  animation-name: thirdPaw;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

@keyframes firstPaw {
  0% {
    opacity: 1;
    transform: translateY(130%);
  }
  10% {
    opacity: 1;
  }
  20% {
    opacity: 1;
  }
  30% {
    opacity: 1;
  }
  40% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  60% {
    opacity: 0;
  }
  70% {
    opacity: 0;
  }
  80% {
    opacity: 0;
  }
  90% {
    opacity: 0;
  }
  100% {
    opacity: 0;
    transform: translateY(-130%);
  }
}

@keyframes secondPaw {
  0% {
    opacity: 0;
    transform: translateY(130%);
  }
  10% {
    opacity: 0;
  }
  20% {
    opacity: 0;
  }
  30% {
    opacity: 0.5;
  }
  40% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  70% {
    opacity: 0.5;
  }
  80% {
    opacity: 0;
  }
  90% {
    opacity: 0;
  }
  100% {
    opacity: 0;
    transform: translateY(-130%);
  }
}

@keyframes thirdPaw {
  0% {
    opacity: 0;
    transform: translateY(130%);
  }
  10% {
    opacity: 0;
  }
  20% {
    opacity: 0;
  }
  30% {
    opacity: 0;
  }
  40% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  60% {
    opacity: 1;
  }
  70% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: translateY(-130%);
  }
}

.loading-screen {
  background: var(--light-clr);
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9999;
  overflow: visible;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-block-start: 15em;
}

.fade-out {
  animation-name: fade-out;
  animation-duration: 0.5s;
  animation-iteration-count: 1;
  opacity: 0;
  /* display: none !important; */
  z-index: -1 !important;
}
</style>
